module.exports = __webpack_public_path__ + "static/media/2C.46b351dd.svg";